module.exports = __webpack_public_path__ + "static/media/s26.c826c19b.jpg";